import { createSelector } from 'reselect';

const selectRoutingModels = (state: any) => state.routingModels;


export const selectRoutingModelsCurrentItem = createSelector([selectRoutingModels], (routingModels) => routingModels.current);

export const selectRoutingModelsListItems = createSelector([selectRoutingModels], (routingModels) => routingModels.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectRoutingModelsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectRoutingModelsQueryItems = createSelector([selectRoutingModels], (routingModels) => routingModels.query);

export const selectRoutingModelsCreatedItem = createSelector([selectRoutingModels], (routingModels) => routingModels.create);

export const selectRoutingModelsUpdatedItem = createSelector([selectRoutingModels], (routingModels) => routingModels.update);

export const selectRoutingModelsReadItem = createSelector([selectRoutingModels], (routingModels) => routingModels.read);

export const selectRoutingModelsDeletedItem = createSelector([selectRoutingModels], (routingModels) => routingModels.delete);

export const selectRoutingModelsSearchedItems = createSelector([selectRoutingModels], (routingModels) => routingModels.search);

export const selectRoutingModelsItemsCount = createSelector([selectRoutingModels], (routingModels) => routingModels.count);

export const selectRoutingModelsItemsFilter = createSelector([selectRoutingModels], (routingModels) => routingModels.filter);